import { GeoJsonObject, Polygon, MultiPolygon } from 'geojson';

export function isPolygon(geoJson: GeoJsonObject): geoJson is Polygon {
  return geoJson.type === 'Polygon';
}

export function isMultiPolygon(geoJson: GeoJsonObject): geoJson is MultiPolygon {
  return geoJson.type === 'MultiPolygon';
}
